import React from "react";

/**
 * Einheitlicher Leer-/Lade-/Fehlerzustand für Übersichten.
 * @param {{
 *   message?: string,
 *   title?: string,
 *   hint?: string,
 *   variant?: "empty" | "loading" | "error",
 *   className?: string,
 *   action?: React.ReactNode,
 * }} props
 */
export function EmptyState({
  message = "",
  title = "",
  hint = "",
  variant = "empty",
  className = "",
  action = null,
}) {
  const role = variant === "error" ? "alert" : "status";
  const heading = title || message;
  const classes = [
    "tm-emptyState",
    `tm-emptyState--${variant}`,
    !title && !hint ? "muted" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role={role}>
      {heading ? (
        <p
          className={title ? "tm-emptyState__title" : "tm-emptyState__message"}
        >
          {heading}
        </p>
      ) : null}
      {hint ? <p className="tm-emptyState__hint muted">{hint}</p> : null}
      {action ? <div className="tm-emptyState__action">{action}</div> : null}
    </div>
  );
}
